export default {
    "name": "CreateDashboardChart",
    "kind": "HoudiniMutation",
    "hash": "e0df074182d5e0f0c46483fe5192c9446c3cd81509c586551e4795bb3394bfb1",

    "raw": `mutation CreateDashboardChart($input: NewDashboardChartInput!) {
  createDashboardChart(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createDashboardChart": {
                "type": "DashboardChart",
                "keyRaw": "createDashboardChart(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "NewDashboardChartInput"
        },

        "types": {
            "NewDashboardChartInput": {
                "dataSourceName": "String",
                "description": "String",
                "jsonString": "String",
                "name": "String",
                "showChart": "Boolean",
                "supertype": "DashboardChartSupertype",
                "title": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=dfa4a8cc8868b5acb47fbc95bcdf2a5a88644d020e09b9ce055576d08f96c721";